// src/components/Headers/UKKHeader.jsx

import { Link } from "react-router-dom";
import ResponsiveButton from "../../components/ResponsiveButton/ResponsiveButton";

// Images
import ukkimage from "../../assets/ukk.jpg";

const text =
  "Usein kysytyt kysymykset. Tervetuloa usein kysyttyjen kysymysten-osioon! Tässä osiossa vastaamme yleisimpiin kysymyksiin, joita asiakkaamme ovat tiedustelleet meiltä. Toivottavasti tämä osio auttaa sinua löytämään vastauksia kysymyksiisi. Mikäli ette löydä vastaustasi, ota rohkeasti yhteyttä! Kysy lomakkeella! paina alla olevaa nappulaa ja kysy lomakkeen kautta!";

const headerCardClass =
  "relative z-10 mx-auto mb-8 max-w-5xl overflow-hidden rounded-[2rem] border border-[#DDE7E5] bg-white/90 p-6 pt-10 shadow-xl backdrop-blur-xl dark:border-darkborder dark:bg-[#111114]/95 sm:p-8 lg:p-10";

const titleClass =
  "font-customFont2 text-5xl font-bold uppercase leading-none !text-[#111827] dark:!text-white sm:text-6xl lg:text-7xl";

const textClass =
  "mt-5 font-customFont1 text-lg leading-relaxed !text-[#374151] dark:!text-[#D1D5DB] sm:text-xl";

const Header = () => {
  return (
    <div className={headerCardClass}>
      <div
        aria-hidden="true"
        className="
          pointer-events-none absolute -right-20 -top-20 h-56 w-56
          rounded-full bg-primary/10 blur-3xl
          dark:bg-primary/10
        "
      />

      <div className="relative grid grid-cols-1 items-center gap-8 md:grid-cols-2">
        {/* Kuvan osio */}
        <div
          data-aos="fade-in"
          className="order-1 flex justify-center md:order-1"
        >
          <div className="relative flex w-full max-w-sm items-center justify-center rounded-[2rem] border border-[#DDE7E5] bg-[#F8FAFC]/80 p-5 shadow-sm dark:border-darkborder dark:bg-darksurface/80">
            <img
              src={ukkimage}
              title="Kaukokaapeli"
              alt="Kaukokaapeli, joka symboloi yhteydenpitoa"
              className="
                relative z-20 max-h-[420px] w-full object-contain
                rotate-[10deg] drop-shadow-[0_18px_35px_rgba(0,0,0,0.30)]
                sm:max-h-[460px]
              "
            />
          </div>
        </div>

        {/* Tekstin osio */}
        <div className="order-2 max-w-2xl">
          <span className="mb-5 inline-flex rounded-full border border-primary/40 bg-primary/10 px-4 py-1.5 font-customFont1 text-xs font-extrabold uppercase tracking-[0.14em] !text-[#111827] shadow-sm dark:!text-white">
            UKK
          </span>

          <h1 className={titleClass} aria-label={text}>
            Usein kysytyt kysymykset
          </h1>

          <p className={textClass} aria-live="polite">
            Tervetuloa usein kysyttyjen kysymysten osioon. Tässä osiossa
            vastaamme yleisimpiin kysymyksiin, joita asiakkaamme ovat
            tiedustelleet meiltä.
            <br />
            <br />
            Toivottavasti FAQ-osio auttaa sinua löytämään vastaukset. Mikäli
            et löydä vastausta kysymykseesi, ota rohkeasti yhteyttä.
          </p>

          <div className="pt-6">
            <Link
              to="/tee-varaus"
              onClick={() =>
                window.scrollTo({ top: 0, left: 0, behavior: "auto" })
              }
            >
              <ResponsiveButton variant="askwithform" aria-label="Kysy lomakkeella">
                Kysy lomakkeella
              </ResponsiveButton>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;